import React, { useState } from "react";
import { StaticImage } from "gatsby-plugin-image";
import PropTypes from "prop-types";
import { useInView } from "react-intersection-observer";

// components
import TeamMemberCard from "../TeamMemberCard";
import BioModal from "../BioModal";

// data
import { memberDetails } from "../MemberDetails";

// styles
import * as styles from "./SeniorAdvisoryBoardNew.module.css";

const teamDetails = [
  {
    id: "patrick-conway",
    drName: "Patrick Conway",
    designation: "MD, MSc CEO of Care Solutions Optum",
    company: "",
    drImage: (
      <StaticImage
        src="../../../images/aboutUs/patrick-conway.png"
        alt="Patrick Conway"
        placeholder="blurred"
        quality={100}
      />
    ),
  },
  {
    id: "ashok-jhunjhunwala",
    drName: "Dr Ashok Jhunjhunwala",
    designation:
      "Former Professor / IIT Madras & President, IITM Research Park",
    company: "",
    drImage: (
      <StaticImage
        src="../../../images/aboutUs/ashok-jhunjhunwala.png"
        alt="Ashok Jhunjhunwala"
        placeholder="blurred"
        quality={100}
      />
    ),
  },
  {
    id: "michelle-harika",
    drName: "Michelle Harika, PharmD",
    designation:
      "Principal at Blackstone and Chief Clinical Officer for Equity Healthcare, Blackstone",
    company: "",
    drImage: (
      <StaticImage
        src="../../../images/aboutUs/michelle-harika.png"
        alt="Michelle Harika"
        placeholder="blurred"
        quality={100}
      />
    ),
  },
  {
    id: "rajiv-kumar",
    drName: "Dr Rajiv Kumar",
    designation:
      "Indian economist who had served as the second vice-chairman of the NITI Aayog",
    company: "",
    drImage: (
      <StaticImage
        src="../../../images/aboutUs/rajiv-kumar.png"
        alt="Rajiv Kumar"
        placeholder="blurred"
        quality={100}
      />
    ),
  },
  {
    id: "shashank-joshi",
    drName: "Shashank Joshi",
    designation:
      "Senior Consultant, Joshi Clinic, Mumbai Stanford University School of Medicine",
    drImage: (
      <StaticImage
        src="../../../images/aboutUs/shashank_v2.png"
        alt="Founder"
        placeholder="blurred"
      />
    ),
    content1:
      "Shashank Joshi, MD is Twin's chief scientist. As an endocrinologist and medical researcher, Dr. Joshi has extensive experience with the treatment and study of diabetes and chronic disease. Before joining Twin, he was the Chair of the South-East Asian International Diabetes Federation and president of several organizations: the Indian Academy of Diabetes, the Endocrine Society of India, the Association of Physicians of India, and the Research Society for Study of Diabetes in India. Dr. Joshi was a member of the faculty at Grant Medical College and Seth GS Medical College, where he earned his MBBS and MD, respectively. He is a fellow of the American College of Endocrinology, the American College of Physicians, and the Royal College of Physicians (London, Glasgow, and Edinburgh).",
    content2:
      "Dr. Joshi has published more than 800 research publications and Stanford University ranked him in the Top 0.5% of all scientists in General and Internal Medicine.",
  },
  {
    id: "frank-williams",
    drName: "Frank Williams",
    designation: "Co-Founder and Executive Chairman",
    company: "Evolent Health",
    drImage: (
      <StaticImage
        src="../../../images/aboutUs/frank-william.png"
        alt="Frank Williams"
        placeholder="blurred"
      />
    ),
  },
  {
    id: "ronald-williams",
    drName: "Ronald A. Williams",
    designation: "Chairman and CEO",
    company: "RW2 Enterprises",
    drImage: (
      <StaticImage
        src="../../../images/aboutUs/ronald-williams.png"
        alt="Ronald A. Williams"
        placeholder="blurred"
        quality={100}
      />
    ),
  },
];

const SeniorAdvisoryBoardNew = ({
  title = "Senior Advisory Board",
  members = teamDetails,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);

  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const handleReadBio = member => {
    // Find full member details from memberDetails
    const fullMemberData = memberDetails.find(m => m.id === member.id);

    if (fullMemberData) {
      setSelectedMember(fullMemberData);
      setShowModal(true);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedMember(null);
  };

  return (
    <>
      <section className={styles.seniorAdvisorySection}>
        <div
          className={`container scroll_animate ${inView && "inview"}`}
          ref={ref}
        >
          {/* Heading */}
          <div className="row">
            <div className="col-12">
              <h2 className={styles.sectionTitle}>{title}</h2>
            </div>
          </div>

          {/* Team Members Grid */}
          <div className={`row ${styles.teamGrid}`}>
            {members.map((member, index) => (
              <div key={index} className="col-6 col-md-6 col-lg-4">
                <TeamMemberCard member={member} onReadBio={handleReadBio} />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Bio Modal */}
      <BioModal
        show={showModal}
        onHide={handleCloseModal}
        member={selectedMember}
      />
    </>
  );
};

SeniorAdvisoryBoardNew.propTypes = {
  title: PropTypes.string,
  members: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      drName: PropTypes.string.isRequired,
      designation: PropTypes.string.isRequired,
      company: PropTypes.string,
      drImage: PropTypes.node.isRequired,
    })
  ),
};

export default SeniorAdvisoryBoardNew;
